import React, { useEffect } from 'react'
import { Typography, Grid } from '@material-ui/core';
import Aceptado from '../../assets/icono-aprobado.png';
import './styles.css'
import { useDispatch, useSelector } from 'react-redux';
import { traerUserAutogestion } from '../../actions/autogestion/userAutogestion';
import { traerPreafiliadoExternoPorCuil } from '../../actions/autogestion/preafiliadoAutogestion';

import {  useParams } from "react-router-dom";
const urlBase= process.env.REACT_APP_URL

export const EstadoConfirmado = () => {

    const {afiliadoEncontrado} = useSelector(state => state.preinscripto)
    const {usuarioAutogestion} = useSelector(state => state.userAutogestion)
    const dispatch = useDispatch();
    const {cuil} = useParams();

    useEffect(() => {
        dispatch(traerUserAutogestion());
        // eslint-disable-next-line
      }, [])

    useEffect(() => {
        if(Object.keys(usuarioAutogestion).length!==0){
            dispatch(traerPreafiliadoExternoPorCuil(cuil));   
        }
        // eslint-disable-next-line
    }, [usuarioAutogestion])


    useEffect(() => {
        if(Object.keys(usuarioAutogestion).length!==0 ){
            const data = {
                cuil:cuil,
                estado:2
            }
            fetch(`${urlBase}/api/Autogestion/CambioEstado`,{
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+usuarioAutogestion.token
                }
            })
            .then(res=>res.json())
            .then(res=>{
                console.log(res);
            })
        }
        // eslint-disable-next-line
    }, [usuarioAutogestion,afiliadoEncontrado])

    return (
    <Grid container style={{background:'white',height: '100vh'}} justify="center">

        <Grid container justify="center" alignItems="center" direction="column" className="estadoContainer estado-confirmado">
            <Typography variant="h5">Informacion enviada: <b>Confirmado</b></Typography>
            <img src={Aceptado} alt="icono de estado de circulación" className="iconoEstado" />
        </Grid>
        <Grid container justify="center">
            <Typography variant="h1"  gutterBottom className="alignmentCenter mainHeadline capitalize">Hola {afiliadoEncontrado?.apellido_y_nombre.toLowerCase()}</Typography>
        </Grid>
        <Grid className="globalContainer">
            <Typography variant="h5" component="h2" className="alignmentCenter secondHeadline">Formulario enviado, para mas informacion comuniquese al 33232323 o consulte <a href="https://www.ospedyc.org/">aqui.</a></Typography>

        <Grid container justify="center" alignItems="center">    
                <Grid container direction="row" justify="center" alignItems="center" className="contenedorMedio timerData">
                        <Typography variant="h5" component="p" color="secondary">Informacion enviada</Typography>
                </Grid>
            
        </Grid>
        </Grid>
    </Grid>
    )
}


